import debug from "debug";

const APP_PREFIX = "dc";

/**
 * Creates a namespaced debug logger gated by localStorage.
 *
 * Enable in browser: localStorage.debug = 'dc:*'
 */
export function createDebugLogger(namespace: string) {
  return debug(`${APP_PREFIX}:${namespace}`);
}
